/**
 * O GRUPO DE RÁDIO do admin atual: "Ambos / Administradora" em Visibilidade Aba
 * (`admin.html:8963`) e "Por mês / Por cliente / Por status" no Relatório PDF (`admin.html:3000`).
 *
 * POR QUE AQUI: o Chassi não tem peça de rádio, e trocar por um `Selecao` mudaria o gesto (um
 * clique numa opção visível viraria abrir uma lista). Esta é a peça que falta, escrita uma vez
 * para o admin inteiro, com o rótulo inteiro como alvo de toque de 44 px e a cor da marca por token.
 *
 * Dona desta peça: a frente A5 (Financeiro e Sistema).
 */

export interface OpcaoDeRadio {
  readonly valor: string;
  readonly rotulo: string;
}

export function GrupoRadio({
  nome,
  opcoes,
  valor,
  aoMudar,
  desabilitado,
  empilhado,
  rotuloDoGrupo,
}: {
  // O `name` comum dos rádios, que faz o navegador tratar o grupo como uma escolha só.
  readonly nome: string;
  readonly opcoes: readonly OpcaoDeRadio[];
  readonly valor: string;
  readonly aoMudar: (valor: string) => void;
  readonly desabilitado?: boolean;
  // Um embaixo do outro, como a lista do Relatório PDF; sem isso, lado a lado.
  readonly empilhado?: boolean;
  // O nome do grupo para o leitor de tela, já que o grupo não tem rótulo visível próprio.
  readonly rotuloDoGrupo?: string;
}) {
  return (
    <span role="radiogroup" aria-label={rotuloDoGrupo} className={`flex gap-cx-3 ${empilhado ? 'flex-col' : 'flex-wrap'}`}>
      {opcoes.map((opcao) => (
        <label
          key={opcao.valor}
          className="inline-flex min-h-toque cursor-pointer items-center gap-cx-2 text-cx-sm text-texto"
        >
          <input
            type="radio"
            name={nome}
            value={opcao.valor}
            checked={valor === opcao.valor}
            disabled={desabilitado}
            onChange={() => aoMudar(opcao.valor)}
            className="h-cx-4 w-cx-4 accent-marca"
          />
          {opcao.rotulo}
        </label>
      ))}
    </span>
  );
}
